import { Local } from '@/utils/storage'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { commonRoutes } from "./route"
import { useUserStore } from "@/store/user"

export const routes: Array<RouteRecordRaw> = [...commonRoutes]

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({
    top: 0
  }),
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = Local.get('token');
  const userStore = useUserStore();

  if (to.path === '/login') {
    if (token) {
      next('/home');
    } else {
      next();
    }
  } else {
    if (!token) {
      next('/login');
    } else {
      // 如果有 token 但没有用户信息，则获取用户信息
      if (!userStore.userInfo.id) {
        try {
          await userStore.getUserInfoAction();
          next({ ...to, replace: true });
        } catch (error) {
          // 获取用户信息失败，可能是 token 过期，跳转登录页
          userStore.logoutAction();
          next('/login');
        }
      } else {
        next();
      }
    }
  }
})

export default router
